export default {"src":"/_next/static/media/indo-flag.37f76e26.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};